/**
 * Zitadel OIDC config for the SPA — the sole auth path (SSO re-architecture,
 * Phase 5).
 *
 * Two sources, in order: a runtime-injected `window.__NAAS_CONFIG__` (the prod
 * web image renders /config.js from env at container start, so one image works
 * across environments and stays decoupled from the post-deploy Zitadel IDs),
 * then build-time `import.meta.env` (dev, from frontend/.env.local). See
 * deploy/zitadel/README.md.
 */
const env = import.meta.env;
const rc = (typeof window !== "undefined" && window.__NAAS_CONFIG__) || {};

export const zitadelConfig = {
  /** e.g. http://localhost:8083 (also the OIDC issuer). */
  authority: rc.authority ?? env.VITE_ZITADEL_AUTHORITY ?? "",
  /** The naas-web SPA client id (public / PKCE). */
  clientId: rc.clientId ?? env.VITE_ZITADEL_CLIENT_ID ?? "",
  /** The naas-api client id — added as a token audience scope. */
  apiAudience: rc.apiAudience ?? env.VITE_ZITADEL_API_AUDIENCE ?? "",
  /** The naas project id — added as an audience scope. */
  projectId: rc.projectId ?? env.VITE_ZITADEL_PROJECT_ID ?? "",
  /** Where Zitadel redirects back after login (must match the app's route). */
  redirectUri:
    (typeof window !== "undefined" ? window.location.origin : "") +
    "/sso/callback",
} as const;
